module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_ks_bpwy.e40efaab.png";